export function assertIsDefined<T>(value: T, context?: string): asserts value is NonNullable<T> {
  if (value === undefined || value === null) {
    const errorMessage = context ? `Value is not defined: ${context}` : 'Value is not defined';
    const error = new Error(errorMessage);
    console.log('Not defined', context ?? '(no context)', error.stack ?? 'No stack trace available');
    throw error;
  }
}
